module.exports = __webpack_public_path__ + "img/pen-size-1.5ad76937.svg";